
export const PASSWORD_SPECIAL_CHARS = `\`!@#$%^&*()_+-=[]{};':"\\|,.<>/?~`
export const PASSWORD_NUMBERS_CHARS = '0123456789'